<template>
  <div class="container">
      <div class="wrapper">
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { API } from '../globals';
export default Vue.extend({
    name: "ConfirmarCuenta", 
    data: () => ({

    }),
    mounted() {
        this.confirmAccount();
    },
    methods: {
        confirmAccount: function(){
            const { token } = this.$route.params;
            const { type } = this.$route.query;

            console.log(token, type)
            axios({
                "url": `${process.env.VUE_APP_BACKEND}/confirm-account/${token}?type=${type}`,
                method: "PUT",
            })
            .then(res => {
                this.$awn.success(res.data);
                this.$router.push("/");
            })
            .catch(err => {
                this.$awn.alert(err.response.data);
                this.$router.push("/");
            });
        }
    }
})
</script>

<style lang="scss" scoped>
    @import "https://fonts.googleapis.com/css?family=Signika&display=swap";

    .container{
        display: flex;
        justify-content: center;
        align-items: center !important;
        height: 100vh;
        .wrapper {
            max-width: 500px;
            width: 500px;
            height: 500px;
            background: transparent url('~/loader.gif') center no-repeat;
            // background: #000;
            background-size: 100px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            &::after {
                content: "Confirmando Cuenta...";
                display: block;
                // width: 100%;
                padding: 20px 0;
                margin-top: 180px;
                font-family: 'Signika';
                font-size: 2em;
                // background: #000;
                // position: absolute;
                // bottom: 35%;
                // text-align: center;
                // left: 0%;
            }
        }
    }

</style>